import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Avatar,
  Zoom,
  Stack,
  styled,
  Tooltip,
  tooltipClasses,
  IconButton,
} from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import { CircularProgress } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import { useTranslation } from "react-i18next";
import { api } from "../../../../../contexts/JWTContext";

import DeleteIcon from "@mui/icons-material/Delete";

const Transition = React.forwardRef((props, ref) => (
  <Zoom ref={ref} {...props} style={{ transitionDelay: "200ms" }} />
));

const CustomWidthTooltipOfDelete = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "red",
  },
});
Transition.displayName = "Transition";

const Item = styled(Box)(({ theme }) => ({
  // backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),

  color: theme.palette.text.secondary,
}));

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
const ProfilePictureModal = ({
  img,
  handleDelete,
  setPostData,
  locationId,
  index,
  isUploading,
  postData,
  afterUploadSelectedChange,
  handleImageError,
}) => {
  const inputFileRef = React.useRef();
  const { t } = useTranslation();
  const [translation] = useTranslation("translation");
  const [isUploaded, setIsUploaded] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [imageArea, setImageArea] = useState(null);

  useEffect(async () => {
    if (isUploading) {
      await uploadImages();
    }
  }, [isUploading]);
  function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }

  const uploadImages = async () => {
    try {
      let tempImages = [];
      let formData = new FormData();

      // selectedImages.forEach((item) => {
      formData.append("photos", img.picture);
      // });

      setIsLoading(true);
      const res = await api.post(`/google/post/${locationId}`, formData, {
        onUploadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / progressEvent.total) * 50;

          setProgress(progress);
        },
        onDownloadProgress: (progressEvent) => {
          const progress =
            50 + (progressEvent.loaded / progressEvent.total) * 50;

          setProgress(progress);
        },
      });

      if (res.status === 200) {
        let tempArray = [];
        res.data.filesArray?.map((item) => {
          tempArray.push({
            locationIds: [],
            content: "",
            startDate: null,
            endDate: null,
            repeat: "no",
            postType: "CALL",
            isUploadPicture: true,
            url: "",
            title: "",
            companyId: "",
            postPictures: [
              {
                url: item?.location,
                key: item?.key,
              },
            ],
          });
          afterUploadSelectedChange(index, item?.key);
        });

        let tempPostData;
        setPostData((state) => {
          tempPostData = state;
          return state;
        });
        setPostData([...tempPostData, tempArray[0]]);
        setIsUploaded(true);
        setIsLoading(false);
      }
    } catch (error) {
      setIsUploaded(false);

      setIsLoading(false);
    }
  };

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Item
          sx={{
            // display: "flex",
            // alignItems: "center",
            gap: "1rem",
          }}
        >
          <Avatar
            variant="square"
            sx={{
              width: "80px",
              height: "80px",
              marginY: "10px",
              borderRadius: "10px",
            }}
            onLoad={(img) => {
              img?.target?.naturalHeight &&
                img?.target?.naturalWidth &&
                setImageArea({
                  height: img?.target?.naturalHeight,
                  width: img?.target?.naturalWidth,
                });
              if (
                img?.target?.naturalHeight < 250 ||
                img?.target?.naturalWidth < 250
              ) {
                handleImageError(index);
              }
            }}
            alt="Remy Sharp"
            src={img?.picturePreview}
          />
        </Item>
        <Item
          sx={{
            paddingLeft: "20px",
            // display: "flex",
            flex: "auto",
            gap: "1rem",
          }}
        >
          <Typography
            sx={{
              // alignItems: "start",

              fontSize: "14px",
              color: "#1B2430",
              fontWeight: "400",
            }}
          >
            {img?.picture?.name.slice(0, 30)}
            {img?.picture?.name?.length > 30 ? "..." : ""}
          </Typography>
          <Typography
            sx={{
              // alignItems: "start",

              fontSize: "13px",
              color: "gray",
              fontWeight: "400",
            }}
          >
            {formatBytes(img?.picture?.size)}{" "}
            {imageArea && `(${imageArea?.width}px/${imageArea?.height}px)`}
          </Typography>
        </Item>
        <Item
          sx={{
            width: "180px",
            // display: "flex",
            // alignItems: "center",
            gap: "1rem",
          }}
        >
          {isLoading ? (
            <Box sx={{ width: "100%" }}>
              <LinearProgress />
            </Box>
          ) : isUploaded === null ? (
            <Grid>
              <Typography
                sx={{
                  // alignItems: "start",

                  fontSize: "14px",
                  color: "#FC3652",
                  fontWeight: "400",
                }}
              >
                {imageArea?.width < 250 || imageArea?.height < 250
                  ? "Min: 250px/250px w/h"
                  : ""}
              </Typography>
            </Grid>
          ) : (
            <Typography
              sx={{
                // alignItems: "start",

                fontSize: "14px",
                color: isUploaded ? "#13CF8F" : "#FC3652",
                fontWeight: "400",
              }}
            >
              {isUploaded ? t("Uploaded_successfully") : t("Uploaded_failed")}
            </Typography>
          )}
        </Item>

        <Item
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          {isUploaded === false ? (
            <CustomWidthTooltipOfDelete
              // color="red"
              title="retry"
            >
              <IconButton
                sx={{
                  color: "#8D9298",
                  width: "20px",
                  height: "18px",
                }}
                disabled={isLoading ? true : false}
                aria-label="retry"
                size="large"
                // color="#8D9298"
                onClick={() => uploadImages()}
              >
                <ReplayIcon />
              </IconButton>
            </CustomWidthTooltipOfDelete>
          ) : (
            <CustomWidthTooltipOfDelete
              // color="#8D9298"
              title={t("Delete")}
            >
              <IconButton
                sx={{
                  color: "#8D9298",
                  width: "20px",
                  height: "18px",
                }}
                disabled={isLoading ? true : false}
                aria-label="delete"
                size="large"
                // color="red"
                onClick={() => handleDelete(index)}
              >
                <DeleteIcon />
              </IconButton>
            </CustomWidthTooltipOfDelete>
          )}
          {/* <DeleteOutlineOutlinedIcon
                            style={{
                              color: "#FC3652",
                              width: "18px",
                              height: "20px",
                            }}
                          /> */}
        </Item>
      </Stack>
    </>
  );
};

export default ProfilePictureModal;
